let colors = [
  '#7ab956',
  '#fbba39'
];

export default [
  {
    type: 'value',
    position: 'left',
    axisLine: {
      lineStyle: {
        color: colors[0]
      }
    },
    axisLabel: {
      formatter: '{value}'
    },
    minInterval: 1
  },
  {
    type: 'value',
    position: 'right',
    axisLine: {
      lineStyle: {
        color: colors[1]
      }
    },
    axisLabel: {
      formatter: '{value}'
    },
    minInterval: 1
  }
]